module.exports = __webpack_public_path__ + "static/media/apple-touch-startup-image-1242x2208.4d18a8e0.png";